<template>
  <br />
  <div class="container" style="text-align: center" v-if="projects.length == 0">
    <div class="spinner-border" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>

  <div class="container">
    <div v-if="projects.length > 0" class="row row-cols-2">
      <div v-for="item in projects" :key="item.id" class="col">
        <div class="card mb-3 shadow rounded">
          <div class="row g-0">
            <div class="col-md-4">
              <img :src="item.image" class="card-img-top cardImage" alt="..." />
            </div>
            <div class="col-md-8">
              <div class="card-body">
                <h5 class="card-title">
                  <b>{{ item.title }}</b>
                </h5>
                <p class="card-text">{{ item.description }}</p>
                <ul>
                  <li
                    v-for="ld in item.longDesc"
                    :key="ld[0]"
                    class="text-muted spanText"
                  >
                    {{ ld }}
                  </li>
                </ul>
                <a :href="item.appleUrl" target="_blank" v-if="item.appleUrl"
                  ><i class="fab fa-apple icon"></i
                ></a>
                <a
                  :href="item.androidUrl"
                  target="_blank"
                  v-if="item.androidUrl"
                  ><i class="fab fa-android icon"></i
                ></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import db from "../db.js";
export default {
  name: "Project",
  data: function () {
    return { projects: [], dialog: "none" };
  },
  methods: {
    openDialog: function () {
      console.log("show Data");
      this.dialog = "block";
    },
    closeDialog: function () {
      console.log("Hide Data");
      this.dialog = "none";
    },
  },
  mounted() {
    db.collection("project").onSnapshot((snapshot) => {
      const snapData = [];
      snapshot.forEach((doc) => {
        snapData.push({
          id: doc.id,
          title: doc.data().title,
          appleUrl: doc.data().apple_url,
          androidUrl: doc.data().android_url,
          image: doc.data().image,
          description: doc.data().description,
          longDesc: doc.data().long_description,
        });
      });

      this.projects = snapData;
      console.log(this.projects);
    });
  },
};
</script>


<style lang="scss" scoped>
* {
  font-family: "Courier New", Courier, monospace;
}
.moreDetail {
  text-align: end;
}
.icon {
  width: 25px;
  height: 25px;
  margin-left: 1rem;
  margin-right: 1rem;
  margin-top: 1rem;
  object-fit: contain;
  color: black;
}

.icon:hover {
  color: blue;
}

.spanText {
  font-size: 14px;
  // font-family: sans-serif;
}

.cardImage {
  width: 10rem;
  height: 10rem;
  object-fit: contain;
  text-align: center;
  padding: 1rem;
}
</style>